export default __webpack_public_path__ + "static/media/Data-researchCr.3ccb233e.png";